<template>
  <div id="app" :style="{transform:scale!==1 && gre150? `scale(${scale})`:'none','paddingTop':deviceLogin?'0px':'68px'}">
    <browseVideo v-if="showVideo" :url="showVideo.url"/>
    <div class="big-nav" :class="{'hidden-nav':deviceLogin}">
      <iheader>
        <inavs slot-scope="{cp}" :cp="cp" />
      </iheader>
    </div>
    <div class="mask" :class="{active: showMask}" :style="{zIndex: maskZIndex}"></div>
    <iaside :active="showLogin" :cp='asideCp'/>
    <ichat />
    <router-view />
    <ifooter v-if="$route.name!=='about'" />
    <ileft />
  </div>
</template>

<script>
import '@/assets/style/reset.scss'
import '@/assets/style/public.scss'
import '@/assets/font/iconfont.css'
import browseVideo from '@/components/browseVideo'
import header from '@/page/layout/header'
import footer from '@/page/layout/footer'
import left from '@/page/layout/left'
import aside from '@/page/layout/aside'
import navs from '@/page/navs'
import chat from '@/page/chat'
import browser from '@/util/browser'
import {mapState} from 'vuex'

export default {
  name: 'App',
  data () {
    return {
      maskZIndex: -1,
      showMask: false,
      showLogin: false,
      asideCp: 'list',
      scale: '',
      isNotChorme: browser.firefox || browser.edge,
      isIE: browser.trident,
      isPad: browser.iPad,
      gre150: false,
      showVideo: false
    }
  },
  watch: {
    '$store.state.user.cart': function (newVal, oldVal) {
      if (newVal && (newVal !== oldVal)) {
        let count = 0
        newVal.forEach(item => {
          count += item.goodsCount
        })
        this.$bus.$emit('updateCart', count)
      }
    },
    '$route.path': {
      handler: function (val, oldVal) {
        if (this.deviceLogin && val !== '/scene' && val !== '/consumption') {
          this.$store.dispatch('logout')
          this.$router.push({name: 'home'})
        }
      },
      // 深度观察监听
      deep: true
    }

  },
  components: {
    iheader: header,
    ifooter: footer,
    iaside: aside,
    inavs: navs,
    ichat: chat,
    ileft: left,
    browseVideo
  },
  computed: {
    ...mapState({
      deviceLogin: state => state.user.deviceLogin
    }),
    isManage: function () {
      if (this.$route.matched.length > 0) {
        return this.$route.matched[0]['name'] === 'manage'
      }
      return false
    },
    routeName: function () {
      return this.$route
    }
  },
  created () {
  },
  mounted () {
    (async () => {
      let res = await this.$store.dispatch('checkToken')
      if (localStorage.currentName === 'manage' && res) {
        this.$router.push({name: 'home'})
      }
    })()

    this.$bus.$on('toggleVideo', (status) => {
      this.showVideo = status
    })

    this.$bus.$on('showMask', (index) => {
      clearTimeout(this.timeout)
      this.maskZIndex = index || 99
      this.showMask = true
    })

    this.$bus.$on('showAside', data => {
      this.showLogin = true
      this.asideCp = data || {type: 'list', sku: [], fromList: true}
    })

    this.$bus.$on('hideAside', () => {
      this.showLogin = false
    })

    this.$bus.$on('hideMask', () => {
      clearTimeout(this.timeout)
      this.showMask = false
      this.timeout = setTimeout(() => {
        this.maskZIndex = -1
      }, 700)
    })

    if (!this.deviceLogin) {
      this.$store.dispatch('getInfo', {url: '/user/getUserInfo', name: 'info'})
      this.$store.dispatch('getCart')
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  padding-top: 68px;
  overflow-x: hidden;
  width: 100%;
  transform-origin: left top;
}

.big-nav {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 999;

}

.hidden-nav{
  height: 0;
  overflow: hidden;
}

.mask {
  z-index: -1;
  display: block;
  background-color: rgba(0,0,0,0);
  transition: background-color .7s cubic-bezier(.77,0,.175,1);
}

.mask.active {
  background-color: rgba(0,0,0,0.4);
}
@media screen and (max-width:600px){
  #app {
    padding-top: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue